import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ReduxFormMaterialTextField, ReduxFormHiddenRecord, ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ServiceShareAddUser.css';
const cx = classNames.bind(styles);

class ServiceShareAddUser extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      reactivateValidate: ''
    };
  }

  componentDidMount() {
    this.setState({ reactivateValidate: 'colap' });
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      onProgress,
      disabledProgress,
      invalid,
      errorMessage,
      formStore,
      prepareProgress,
      handleOnToggleAModal,
      handleOnKeyUp
    } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'share-service', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleAModal}
        visible
        header={defineMessages(formatMessage({ id: 'ServiceShareAddUser_1', defaultMessage: '공유 사용자 추가' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleAModal}>
              {defineMessages(formatMessage({ id: 'ServiceShareAddUser_2', defaultMessage: '닫 기' }))}
            </Btn>
            <Btn
              className={cx('brand-button')}
              loading={onProgress}
              disabled={onProgress || (disabledProgress && invalid)}
              onClick={prepareProgress}>
              {defineMessages(formatMessage({ id: 'ServiceShareAddUser_3', defaultMessage: '추 가' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(formatMessage({ id: 'ServiceShareAddUser_4', defaultMessage: '처리중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ServiceShareAddUser_5',
              defaultMessage: '공유할 대상자의 이메일을 입력하세요.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'ServiceShareAddUser_7',
              defaultMessage: '본 서비스에 가입된 대상자만 가능합니다.'
            })
          )}
        </div>
        <Message info className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'ServiceShareAddUser_6', defaultMessage: '공유 사용자 이메일' }))}
            </span>
            <ReduxFormMaterialTextField
              required
              fullWidth
              error={!!errorMessage}
              name="shareUserEmail"
              className={cx('input-area')}
              checkType={101}
              validate={['required', 'email']}
              onKeyUp={handleOnKeyUp}
              userCheck={errorMessage}
            />
            {/* 아래 Input 은 redux-form 버그로 인한 임시방편 */}
            <ReduxFormHiddenRecord
              name="examReactiveValidator"
              validate={['maxLength100']}
              valuePass={this.state.reactivateValidate}
            />
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

export default injectIntl(ServiceShareAddUser);



// WEBPACK FOOTER //
// ./src/script/components/share/ServiceShareAddUser.js